import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const naturalWeaning: BlogMetaData = {
  title: '卒乳はいつから？子どものペースで進める自然卒乳の目安とサイン',
  description:
    '卒乳はいつから始めればいい？子どものペースで自然に授乳が終わる「自然卒乳」の目安やサイン、断乳との違い、体調に不安があるときの相談先までモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-natural-weaning.webp',
  filePath: buildBlogFilePath('natural-weaning'),
  category: BLOG_CATEGORY.PARENTING,
};
